import * as types from '../actions/types';
import { createTypes } from '../actions/createTypes';

const initialState = {
  data: {
    phone_country_code: '',
    phone_number: '',
  },
  isLoading: false,
  error: null,
};

export const userPhoneNumber = (state = initialState, action = {}) => {
  switch (action.type) {
    case createTypes(types.USER_PHONE_NUMBER).loading:
      return {
        ...state,
        isLoading: action.payload,
      };
    case createTypes(types.USER_PHONE_NUMBER).success:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };
    case createTypes(types.USER_PHONE_NUMBER).error:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};